import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ValueWithRandom } from "../../ValueWithRandom";
export var ZIndex = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(ZIndex, _ValueWithRandom);

  var _super = _createSuper(ZIndex);

  function ZIndex() {
    var _this;

    _classCallCheck(this, ZIndex);

    _this = _super.call(this);
    _this.opacityRate = 1;
    _this.sizeRate = 1;
    _this.velocityRate = 1;
    return _this;
  }

  _createClass(ZIndex, [{
    key: "load",
    value: function load(data) {
      _get(_getPrototypeOf(ZIndex.prototype), "load", this).call(this, data);

      if (!data) {
        return;
      }

      if (data.opacityRate !== undefined) {
        this.opacityRate = data.opacityRate;
      }

      if (data.sizeRate !== undefined) {
        this.sizeRate = data.sizeRate;
      }

      if (data.velocityRate !== undefined) {
        this.velocityRate = data.velocityRate;
      }
    }
  }]);

  return ZIndex;
}(ValueWithRandom);